import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Button, link } from "antd";
import "../../styles/db.css";
export default function SearchFilter({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}) {
  return (
    <>
      <Input
        className="search-filter"
        autoFocus="true"
        placeholder="Type text here"
        value={selectedKeys}
        onChange={(e) => {
          setSelectedKeys(e.target.value ? [e.target.value] : []);
        }}
        onPressEnter={() => {
          confirm();
        }}
        onBlur={() => {
          confirm();
        }}
        suffix={
          <>
            <SearchOutlined
              onClick={() => {
                confirm();
              }}
            />
            <Button
              className="ant-btn css-xu9wm8 ant-btn-link ant-btn-sm"
              style={{ border: "none" }}
              onPressEnter={() => {
                clearFilters();
              }}
              onBlur={() => {
                clearFilters();
                confirm();
              }}
              onClick={() => {
                clearFilters();
              }}
            >
              Reset
            </Button>
          </>
        }
      />
    </>
  );
}
